"use strict";

import Page from "./Properties.jsx";

export const auth = true;
export const title = "Account";
export const Component = Page;
